import { useQuery } from "@tanstack/react-query";
import { getAllBlogsForDetailPage } from "../../../../components/UserPanel/HomePage/TrendingBlogSection/services/blogsService";

// Blog list (object-shaped) — powers BlogDetails' sidebar "Recent Post" list, search,
// Previous/Next navigation, and Related Blogs, all derived client-side from this one array.
// Built from the light /blog/filter endpoint (~52 KB) rather than GET /blog (~5.4 MB of article bodies).
export const useAllBlogs = () => {
  return useQuery({
    queryKey: ["all-blogs-light"],
    queryFn: getAllBlogsForDetailPage,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
